import React from "react";
import app from '../assets/app.jpg';

const AppAd = () => {
  const handleClick = () => {
    window.location.href = "https://play.google.com/store/apps/details?id=com.gtoyo.Devotiona&pcampaignid=web_share";
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-100 rounded-2xl shadow-2xl text-center w-screen">
      <img 
        src={app}
        alt="App Logo" 
        className="w-32 h-32 mb-6 rounded-lg sm:w-40 sm:h-40"
      />
      <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">Download Our App</h2>
      <p className="text-gray-700 mt-3 text-lg sm:text-xl">Get the best experience by downloading our app from the Play Store.</p>
      <button 
        onClick={handleClick} 
        className="mt-6 bg-gray-300 text-black px-8 py-3 text-lg rounded-xl shadow-lg hover:bg-gray-400 transition duration-300 sm:px-10 sm:py-4 sm:text-xl"
      >
        Download Now
      </button>
    </div>
  );
};

export default AppAd;